import React from "react";
import "./style.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <footer className='footer-desktop'>
        <div className='container-1280'>
          <div className='row footer-logo'>
            <div className='col-lg-2'>
              <a
                className='navbar-brand'
                href
                onClick={(e) => {
                  e.preventDefault();
                }}>
                <img
                  src={require("../../Assets/img/logo.png")}
                  alt='img-logo'
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                />
              </a>
            </div>
            <div className='col-lg-10'>
              <span className='gradient-bar'>
                <img
                  src={require("../../Assets/img/bar.png")}
                  className='img-fluid'
                  alt='bar'
                />
              </span>
            </div>
          </div>

          <div className='row justify-content-between'>
            <div className='col-lg-2 col-md-6 col-sm-12'>
              <p className='std-p'>Company</p>
              <ul className='footer-list'>
                <li>
                  <Link to='/'> Home </Link>
                </li>
                <li>
                  <Link to='/about'>About Us</Link>
                </li>
                <li>
                  <Link to='/IntegrationService'>Integration Services</Link>
                </li>
                <li>
                  <Link to=''>Media Assets</Link>
                </li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-6 col-sm-12'>
              <p className='std-p'>Play</p>
              <ul className='footer-list'>
                <li>
                  <Link to='/games'> Explore Games </Link>
                </li>
                <li>
                  <Link to='/nftjourney'>NFT's</Link>
                </li>
                <li>
                  <Link to='/dashboard'>Dashboard</Link>
                </li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-6 col-sm-12'>
              <p className='std-p'>Resources</p>
              <ul className='footer-list'>
                <li>
                  <Link to='/Blog'>Blogs</Link>
                </li>
                <li>
                  <Link to='/Roadmap'>RoadMap</Link>
                </li>
                <li>
                  <Link to='/Developer'>Developer Docs</Link>
                </li>
                <li>
                  <Link to=''>Gitbook</Link>
                </li>
                <li>
                  <Link to=''>Whitepapper</Link>
                </li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-6 col-sm-12'>
              <p className='std-p'>Useful Links</p>
              <ul className='footer-list'>
                <li>
                  <Link to='/Contact-Support'>Contact Support</Link>
                </li>
                <li>
                  <Link to='/'>FAQ's</Link>
                </li>
                <li>
                  <Link to='/terms-of-use'>Terms Of Use</Link>
                </li>
                <li>
                  <Link to='/cookie-policy'>Cookie Policy</Link>
                </li>
                <li>
                  <Link to='/privacy-policy'>Privacy Policy</Link>
                </li>
                <li>
                  <Link to='/Contact-us'>Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-6 col-sm-12'>
              <p className='std-p'>Follow Us on</p>
              <ul className='footer-list icons'>
                <li>
                  <a
                    href
                    onClick={(e) => {
                      e.preventDefault();
                    }}>
                    <i className='fa fa-facebook-official' aria-hidden='true'></i>{" "}
                  </a>
                </li>
                <li>
                  <a
                    href
                    onClick={(e) => {
                      e.preventDefault();
                    }}>
                    <i className='fa fa-instagram' aria-hidden='true'></i>
                  </a>
                </li>
                <li>
                  <a
                    href
                    onClick={(e) => {
                      e.preventDefault();
                    }}>
                    <i className='fa fa-twitter-square' aria-hidden='true'></i>
                  </a>
                </li>
                <li>
                  <a
                    href
                    onClick={(e) => {
                      e.preventDefault();
                    }}>
                    <i className='fa fa-youtube-square' aria-hidden='true'></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-7'>
              <p className='std-p light'>
                ©2022. All rights reserved. Gaming Arcade.{" "}
                <Link className='m-1' to='/terms-of-use'>
                  Terms & Condition
                </Link>
                Applied
              </p>
            </div>
          </div>
          <div className='row btm-bar'>
            <a
              className='footer-copyright'
              onClick={() => openInNewTab("https://zeltatech.com")}>
              <p className='std-p light'>Made with ❤ by Zelta Tech.</p>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
